// extracted by mini-css-extract-plugin
export default {"content":"CatalogGroup-module__content--sTcWu","group":"CatalogGroup-module__group--dO7Cw"};